module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dxB2Y"))).then(() => parcelRequire('dJXJK'));